import { render, staticRenderFns } from "./EditRights.vue?vue&type=template&id=6755801e&"
import script from "./EditRights.vue?vue&type=script&lang=js&"
export * from "./EditRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6755801e')) {
      api.createRecord('6755801e', component.options)
    } else {
      api.reload('6755801e', component.options)
    }
    module.hot.accept("./EditRights.vue?vue&type=template&id=6755801e&", function () {
      api.rerender('6755801e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/EditRights.vue"
export default component.exports